// extracted by mini-css-extract-plugin
module.exports = {"urlPreview":"UrlPreview_urlPreview__2W2xv","theme-for-table":"UrlPreview_theme-for-table__1wnQl","theme-for-rows":"UrlPreview_theme-for-rows__fSEUr"};